import React, { Fragment, useEffect, useState } from 'react'
import { Button, Container, Nav, Navbar, Offcanvas } from 'react-bootstrap'
import { Logo, NotifIcon } from '../assets/images'
import { useSelector, useDispatch } from 'react-redux';
import { logout, handleVerifyCode } from '../hooks/auth'
import { SnackBar } from '../hooks/Common'
import RedirectPage from "./RedirectPage"
import SessionTimeout from "./SessionTimeout"
import { useParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom"
import SecretCodeDialog from './SecretCodeDialog';
import "../styles/custom-styles.css"
import "../styles/responsive.css"
import "../assets/fonts/proxima-nova.css"

const getBasePath = (auth, cToken) => {
  var path = "/login"
  if (auth.access_token !== null) {
    path = auth.baseline ? "/dashboard" : "/alertness"
  } else if (cToken !== undefined) {
    path = `/${cToken}`
  }
  return path
}

const NavbarComp = (props) => {
  const navigate = useNavigate();
  const { cToken } = useParams();
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const auth = useSelector((state) => state.auth)
  const dispatch = useDispatch();
  const [isScrolled, setIsScrolled] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
  };
  const handleVerify = (code) => {
    dispatch(handleVerifyCode({code,id:auth.user.id}));
  };
  

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY
      setIsScrolled(scrollTop >= 50)
      setShowBackToTop(scrollTop > 50)
    };


    if ('onbeforeinstallprompt' in window) {
      window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
    }
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)

      window.removeEventListener("scroll", handleScroll)
    };
  }, []);

  const handleBeforeInstallPrompt = (e) => {
    e.preventDefault();
    setDeferredPrompt(e);
  }

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          dispatch(SnackBar(true, "User accepted the A2HS prompt", 'info'))
        } else {

          dispatch(SnackBar(true, "User dismissed the A2HS prompt", 'danger'))
        }
      });
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  const handlePath = (path) => {
    navigate(path)
  }

  return (
    <>
      {[false].map((expand) => (
        <Navbar
          key={expand}
          expand={expand}
          className={`bg-body-tertiary mb-3 ${isScrolled ? "scrolled" : ""}`}
        >
          <Container>
            <Navbar.Brand onClick={() => handlePath(getBasePath(auth, cToken))}>
              <img src={Logo} alt="Logo" />
            </Navbar.Brand>
            {auth.user !== null ?
              <div className="nav-right">
                <img src={NotifIcon} alt="Notifications" />
                <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
              </div> : null}
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end" className={props.bgblue ? "bg-blue-style" : null}
            >
              <Container>
                <Offcanvas.Body>
                  <Nav className="justify-content-end flex-grow-1">
                    {auth.baseline ? <Nav.Link onClick={() => handlePath("/dashboard")}>Dashboard</Nav.Link> :
                      <Nav.Link onClick={() => handlePath("/alertness")}>Alertness</Nav.Link>}
                    <Nav.Link onClick={() => handlePath("/profile")}>Profile</Nav.Link>
                    <Nav.Link onClick={() => handlePath("/reminders")}>Reminders</Nav.Link>
                    <Nav.Link onClick={() => handlePath("/change-pin")}>Change PIN </Nav.Link>
                    {deferredPrompt && (
                      <Nav.Link onClick={handleInstallClick}>Add App to Phone</Nav.Link>
                    )}
                    <Nav.Link onClick={() => handlePath("/contact-us")}>Contact Us</Nav.Link>
                    {auth.user !== null ? <Nav.Link onClick={handleLogout}>Logout</Nav.Link> : null}
                  </Nav>
                </Offcanvas.Body>
              </Container>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
      {showBackToTop && (
        <Button className='backtotop' onClick={scrollToTop}>
          <i class="bi bi-caret-up-fill"></i>
        </Button>
      )}
      <RedirectPage access_token={props.access_token} />
      {/* <SessionTimeout handleLogout={handleLogout} />  */}
      {auth.access_token !== null ?
        <Fragment>
            <SessionTimeout handleLogout={handleLogout} /> 
            <SecretCodeDialog
              show={auth.two_factor_dialog}
              onVerify={handleVerify}
            />
        </Fragment>
        : null}
      
    </>
  );
};

export default NavbarComp;